"use client";

import { useEffect } from "react";
import { usePathname, useRouter } from "@/i18n/navigation";
import { useIsMaintenanceMode } from "./useIsMaintenanceMode";
import { useMaintenanceBypass } from "./useMaintenanceBypass";

export function useMaintenanceCheck() {
  const router = useRouter();
  const pathname = usePathname();
  const isMaintenanceEnabled = useIsMaintenanceMode();
  const { isAllowed, isResolved } = useMaintenanceBypass(isMaintenanceEnabled);

  useEffect(() => {
    // `isResolved` is the load-bearing term. The allowlist answer depends on a
    // wallet that arrives asynchronously (auth rehydrate, then the wagmi config
    // swap), so redirecting before it settles would bounce exactly the people
    // the allowlist exists to let through — and once on /maintenance they have
    // no way back. Waiting costs a non-allowlisted visitor a moment on the page
    // they were already looking at.
    if (!isMaintenanceEnabled || !isResolved || isAllowed) return;
    if (pathname === "/maintenance") return;

    router.replace("/maintenance");
  }, [isMaintenanceEnabled, isResolved, isAllowed, pathname, router]);
}
